import React, { useState } from 'react';
import { Mail, Lock, Eye, EyeOff, ArrowLeft, CreditCard } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

const UyeGirisi = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle login logic
  };

  return (
    <div className="min-h-screen bg-slate-50 flex">
      {/* Left Column - Form */}
      <div className="flex-1 flex flex-col">
        <div className="p-8">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors"
          >
            <ArrowLeft size={20} />
            <span>Geri Dön</span>
          </button>
        </div>

        <div className="flex-1 flex items-center justify-center p-8">
          <div className="w-full max-w-md">
            <div className="text-center mb-8">
              <div className="flex items-center justify-center gap-2 mb-6">
                <CreditCard size={32} className="text-[#F7BA45]" />
                <span className="text-2xl font-bold text-slate-800">KREDİPARK</span>
              </div>
              <h1 className="text-2xl font-bold text-slate-800 mb-2">
                Hoş Geldiniz!
              </h1>
              <p className="text-slate-600">
                Hesabınıza giriş yapın
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Email Input */}
              <div className="space-y-2">
                <label className="block text-sm font-medium text-slate-700">
                  E-posta Adresi
                </label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={20} />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="ornek@email.com"
                    className="w-full h-12 pl-10 pr-4 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45] transition-colors"
                  />
                </div>
              </div>

              {/* Password Input */}
              <div className="space-y-2">
                <label className="block text-sm font-medium text-slate-700">
                  Şifre
                </label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={20} />
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    className="w-full h-12 pl-10 pr-12 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45] transition-colors"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600"
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>

              {/* Remember Me & Forgot Password */}
              <div className="flex items-center justify-between">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" className="rounded border-slate-300 text-[#F7BA45] focus:ring-[#F7BA45]" />
                  <span className="text-sm text-slate-600">Beni hatırla</span>
                </label>
                <button type="button" className="text-sm text-[#F7BA45] hover:text-[#e5ac3d] font-medium">
                  Şifremi unuttum
                </button>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-[#F7BA45] hover:bg-[#e5ac3d] text-slate-900 font-medium h-12 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Giriş Yap
              </button>

              {/* Register Link */}
              <p className="text-center text-sm text-slate-600">
                Hesabınız yok mu?{' '}
                <Link to="/uye-ol" className="text-[#F7BA45] hover:text-[#e5ac3d] font-medium">
                  Üye Olun
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>

      {/* Right Column - Image */}
      <div className="hidden lg:block w-1/2 bg-cover bg-center" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1579621970795-87facc2f976d?q=80&w=2070&auto=format&fit=crop)' }}>
        <div className="h-full bg-gradient-to-br from-[#F7BA45]/90 to-amber-600/90 backdrop-blur-sm p-12 flex items-center">
          <div className="max-w-lg">
            <h2 className="text-4xl font-bold text-white mb-6">
              Türkiye'nin En Kapsamlı Kredi ve Banka Karşılaştırma Platformu
            </h2>
            <p className="text-white/90 text-lg">
              Kredipark ile en uygun kredi ve kredi kartı tekliflerini karşılaştırın, 
              size en uygun olanı seçin.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UyeGirisi;